import React from 'react'
import { Card } from 'react-bootstrap'
import moment from 'moment'

const BookingTooltip = ({ event }) => {
  if (!event || !event.extendedProps) {
    console.log('BookingTooltip: No event or extendedProps', { event })
    return null
  }

  const props = event.extendedProps
  console.log('BookingTooltip: Raw database data', {
    start_date_from_db: props.start_date,
    end_date_from_db: props.end_date,
    formatted_start_utc: props.start_date
      ? moment.utc(props.start_date).format('DD/MM/YYYY, h:mm a')
      : 'N/A',
    formatted_end_utc: props.end_date
      ? moment.utc(props.end_date).format('DD/MM/YYYY, h:mm a')
      : 'N/A',
    formatted_start_local: props.start_date
      ? moment(props.start_date).format('DD/MM/YYYY, h:mm a')
      : 'N/A',
    formatted_end_local: props.end_date
      ? moment(props.end_date).format('DD/MM/YYYY, h:mm a')
      : 'N/A'
  })

  return (
    <div style={{ position: 'relative' }}>
      <Card
        className='booking-tooltip'
        style={{
          position: 'relative',
          zIndex: 1000,
          minWidth: '300px',
          maxWidth: '400px',
          backgroundColor: '#2c3e50',
          color: '#ecf0f1',
          border: 'none',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          fontSize: '0.875rem'
        }}
      >
        <Card.Body style={{ padding: '12px' }}>
          <div style={{ marginBottom: '8px' }}>
            <strong style={{ color: '#3498db' }}>
              {props.event_type || 'Booking'} :{' '}
              {props.event_code || props.id || event.id}
            </strong>
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>Start Date :</strong>{' '}
            {props.start_date
              ? 
              //moment.utc(props.start_date).format('DD/MM/YYYY, h:mm a')
              moment(props.start_date).format('DD/MM/YYYY, h:mm a')
              : '-'}
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>End Date :</strong>{' '}
            {props.end_date
              ? 
              //moment.utc(props.end_date).format('DD/MM/YYYY, h:mm a')
              moment(props.end_date).format('DD/MM/YYYY, h:mm a')
              : '-'}
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>Name :</strong> {props.name || '-'}
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>Email :</strong> {props.email || '-'}
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>Phone :</strong> {props.phone || '-'}
          </div>

          <div style={{ marginBottom: '4px' }}>
            <strong>No of Persons :</strong> {props.no_of_persons || '0'}
          </div>

          <div style={{ marginBottom: '0' }}>
            <strong>Description :</strong> {props.description || '-'}
          </div>
        </Card.Body>
      </Card>

      {/* Arrow pointing down */}
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '6px solid #2c3e50'
        }}
      />
    </div>
  )
}

export default BookingTooltip
